'use strict';

var enabled = false;

module.exports = {
  debug: {
    enabled: enabled    
  }
};
